import Link from 'next/link';
import Button from '../button';
import LoadableImage from '../loadable-image';
import { images, availableCopiesText, titlePhotoPath, mapSortBy, mapQueryBy } from 'sdk';
import { Title } from 'types';
import Links from '~/lib/helpers/link-helper';
import styles from '~/styles/components/product/title-details.module.scss';

export default function TitleDetails({ title }: { title: Title; }) {

  if (!title) return null;

  return (
    <section>
      <div className={styles['title-details']}>
        <h2>Discover more</h2>
        <Link href={Links.title(title).show} passHref className={styles['title-details-image']}>
          <LoadableImage src={images(titlePhotoPath(title)).book.thumb} width={250} height={250} alt={title.title} />
        </Link>
        <div className={styles['title-details-content']}>
          <Link href={Links.title(title).show} passHref>
            <h2>{title.title}</h2>
          </Link>
          {title.authors && (
            <h3>
              <span>By: </span>
              {title.authors?.[0]?.name}
            </h3>
          )}
          {title.copies ? <p>{availableCopiesText(title)}</p> : null}
        </div>
        <div className={styles['title-details-link']}>
          <Button
            text='Shop all'
            size='small'
            style='outline'
            disabled={title?.copies === 0}
            link={{
              href: Links.searchWithQueryAppRouter({
                pathname: '/search',
                path: '/search',
                options: {
                  index: 'books',
                  params: {
                    q: '*',
                    sort_by: mapSortBy('books'),
                    query_by: mapQueryBy('books'),
                    filter_by: `title_id:${title.id}`,
                  },
                  options: {},
                },
              }),
            }}
          />
        </div>
      </div>
    </section>
  );
}
